<template>
    <form action="">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Edit Task</p>
            </header>

            <section class="modal-card-body">
                <o-field label="Title" :type="fieldType('title')" :message="getError('title')">
                    <o-input v-model="copy.title" />
                </o-field>

                <o-field label="Location" :type="fieldType('location')" :message="getError('location')">
                    <o-select placeholder="Select a Task Location" v-model="copy.location" expanded>
                        <option :value="null">Not Specified</option>
                        <option
                                v-for="(location, key) in taskLocations"
                                :key="key"
                                :value="location.id"
                        >
                            {{ location.name }}
                        </option>
                    </o-select>
                </o-field>

                <o-field label="Status" :type="fieldType('status')" :message="getError('status')">
                    <o-select placeholder="Select a status" v-model="copy.status" expanded>
                        <option
                                v-for="status in taskStatuses"
                                :value="status.id"
                                :key="status.id"
                        >
                            {{ status.name }}
                        </option>
                    </o-select>
                </o-field>
                <div class="columns">
                    <div class="column">
                        <o-field label="Assigned To" :type="fieldType('assignee_id')" :message="getError('assignee_id')">
                            <autocomplete-select type="user" v-model="copy.assignee_id" :value="userById(copy.assignee_id)" />
                        </o-field>
                    </div>
                    <div class="column">
                        <o-field label="Project" :type="fieldType('project_id')" :message="getError('project_id')">
                            <autocomplete-select type="project" v-model="copy.project_id" :value="projectById(copy.project_id)" />
                        </o-field>
                    </div>
                </div>
                <div class="columns" v-if="isProjectSelected">
                    <div class="column">
                        <o-field label="Contact" :type="fieldType('contact_id')" :message="getError('contact_id')">
                            <o-select placeholder="Select a Task Contact" v-model="copy.contact_id" expanded>
                                <option :value="null">Not Specified</option>
                                <option
                                        v-for="(contact, key) in projectContactsByProjectId(copy.project_id)"
                                        :key="key"
                                        :value="contact.id"
                                >
                                    {{ contactNameById(contact.id) }}
                                </option>
                            </o-select>
                        </o-field>
                    </div>
                    <div class="column">
                        <o-field label="Associated With" :type="fieldType('project_service_id')" :message="getError('location')">
                            <o-select placeholder="Select a Service" v-model="copy.project_service_id" expanded>
                                <option
                                        v-for="service in availableProjectServices"
                                        :value="service.id"
                                        :key="service.id">
                                    {{ service.title }}
                                </option>
                            </o-select>
                        </o-field>
                    </div>
                </div>

                <div class="field">
                    <o-checkbox :value="copy.is_milestone" disabled>Is Milestone</o-checkbox>
                </div>

                <div class="field">
                    <o-checkbox v-model="copy.is_package_log">Is activity package log</o-checkbox>
                </div>

                <div class="between-center" v-if="isProjectSelected">
                    <o-field style="flex: 1" label="Related To" :type="fieldType('category_id')" :message="getError('category_id')">
                        <o-select placeholder="Select a Category" v-model="selectedApplication" expanded>
                            <option value="" selected>Not Specified</option>
                            <option
                                    v-for="(application, i) in applicationsByProjectId(copy.project_id)"
                                    :value="application"
                                    :key="i"
                            >
                                {{ applicationName(application) }}
                            </option>
                        </o-select>
                    </o-field>
                    <div class="field" style="margin: 20px 0 0 10px">
                        <a style="width: 170px" @click="isApplicationModalActive = true" class="button is-primary">Add Application</a>
                    </div>
                </div>

                <o-field v-if="isApplicationTypeFieldVisible" label="Application Type" :type="fieldType('application_type')" :message="getError('application_type')">
                    <o-select placeholder="Select an Application Type" v-model="copy.application_type" expanded>
                        <option value="" selected>Not Specified</option>
                        <option
                                v-for="applicationType in applicationTypes"
                                :value="applicationType.id"
                                :key="applicationType.id">
                            {{ applicationType.name }}
                        </option>
                    </o-select>
                </o-field>

                <o-field v-if="isApplicationIdFieldVisible" label="Application" :type="fieldType('application_id')" :message="getError('application_id')">
                    <o-select placeholder="Select an Application" v-model="copy.application_id" expanded>
                        <option
                                v-for="application in applications"
                                :value="application.id"
                                :key="application.id">
                            {{ applicationName(application) }}
                        </option>
                    </o-select>
                </o-field>

                <template v-if="copy.category_id == 1">
                    <o-field label="Date Requested">
                        <datepicker :error="getError('date_requested')" v-model="copy.date_requested" />
                    </o-field>
                    <o-field label="Date Sent">
                        <datepicker :error="getError('date_sent')" v-model="copy.date_sent" />
                    </o-field>
                    <o-field label="Date Received">
                        <datepicker :error="getError('date_received')" v-model="copy.date_received" />
                    </o-field>
                </template>

                <o-field label="Date Created">
                    <datepicker :error="getError('date_created')" :value="copy.date_created" />
                </o-field>

                <div class="columns">
                    <div class="column">
                        <o-field label="Due Date">
                            <datepicker :error="getError('due_date')" :value="copy.due_date" />
                        </o-field>
                    </div>
                    <div class="column">
                        <o-field label="Date Completed">
                            <datepicker :error="getError('date_completed')" :value="copy.date_completed" />
                        </o-field>
                    </div>
                </div>

                <div class="field">
                    <quill-editor v-model:content="copy.description" :content-type="'html'" />
                </div>
            </section>

            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
                <button @click.prevent="handleSubmit" v-submit="submitting" class="button is-primary">Save</button>
            </footer>
        </div>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isApplicationModalActive" has-modal-card>
            <application-modal @select="selectApplication" />
        </o-modal>
    </form>
</template>

<script>
    import { QuillEditor } from '@vueup/vue-quill';
import { mapActions, mapGetters } from 'vuex';
import ApplicationModal from '../../../components/modals/applications/Layout';
import Datepicker from './../../../components/Datepicker';
import HandlesForm from './../../../mixins/HandlesForm';

    export default {
        mixins: [HandlesForm],

        props: {
            item: {
                type: Object,
                required: true
            }
        },

        components: {
            ApplicationModal,
            Datepicker,
            QuillEditor
        },

        data() {
            return {
                isApplicationModalActive: false,
                taskLocations: [],
            }
        },

        computed: {
            ...mapGetters([
                'projectContactsByProjectId',
                'applicationsByProjectId',
                'applicationTypes',
                'applicationName',
                'contactNameById',
                'projectNameById',
                'taskStatuses',
                'allUsers',
                'projects',
                'projectById',
                'userById',
                'projectServicesByProjectId'
            ]),

            isProjectSelected() {
                return this.copy.project_id
            },

            isApplicationTypeFieldVisible() {
                return this.isProjectSelected && this.copy.category_id == 1
            },

            isApplicationIdFieldVisible() {
                return this.copy.category_id == 1 && _.find(this.applicationTypes, (type) => type.id == this.copy.application_type)
            },

            applications() {
                return this.copy.application_type && this.copy.project_id
                    ? this.$store.getters[`${this.copy.application_type}s/currentProjectItems`]
                    : []
            },

            selectedApplication: {
                get() {
                    return _.find(this.applications, (application) => application.id == this.copy.application_id)
                },
                set(application) {
                    this.selectApplication(application)
                }
            },
            availableProjectServices(){
                return _.filter(this.projectServicesByProjectId(this.copy.project_id), service => service.type != 'optional' &&  this.isStatusValid(service.status));
            }
        },

        watch: {
            'copy.project_id'(project_id) {
                if (project_id) {
                    this.fetchProjectById(project_id).then(() => {
                        this.setCurrentProjectId(project_id)
                        if( this.availableProjectServices.filter(q => q.id == this.copy.project_service_id).length == 0 ) {
                            this.copy.project_service_id = null;
                        }
                    })
                } else {
                    this.copy.category_id = this.copy.application_type = this.copy.application_id = ''
                }
            }
        },

        methods: {
            ...mapActions({
                updateTask: 'updateTask',
                fetchProjectById: 'fetchProjectById',
                fetchTaskBasedCompanies: 'fetchTaskBasedCompanies',
                setCurrentProjectId: 'setCurrentProjectId'
            }),

            handleSubmit() {
                let submit = this.wrapSubmit(this.updateTask)
                this.copy.due_date = this.copy.due_date ? moment(this.copy.due_date).format('YYYY-MM-DD') : null
                this.copy.date_created = this.copy.date_created ? moment(this.copy.date_created).format('YYYY-MM-DD') : null
                this.copy.date_completed = this.copy.date_completed ? moment(this.copy.date_completed).format('YYYY-MM-DD') : null

                submit(this.copy)
                    .then(res => {
                        this.successMessage('Task has been successfull updated')
                        this.$parent.$parent.$emit('update:active', false)
                        return res
                    })
            },

            selectApplication(application) {
                this.copy.application_id = application.id
                this.copy.application_type = application.type
            },
            isStatusValid(status) {
                return ['approved','not_billable'].includes(status)
            }
        },

        mounted() {
            this.copy = _.cloneDeep(this.item)
            this.copy.due_date = this.copy.due_date ? moment(this.copy.due_date).format('YYYY-MM-DD') : null
            this.copy.date_created = this.copy.date_created ? moment(this.copy.date_created).format('YYYY-MM-DD') : null
            this.copy.date_completed = this.copy.date_completed ? moment(this.copy.date_completed).format('YYYY-MM-DD') : null

            this.fetchTaskBasedCompanies().then(res => {
                this.taskLocations = res.data.data
            })
        }
    }
</script>
